module.exports = __webpack_public_path__ + "img/te-11.a94af4d1.png";